import AudioFileIcon from "@mui/icons-material/AudioFile";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { AUDIOLOGY_SELECT_PROMPT, getEmptyPanelPrompt } from "./utils";

const STYLES = {
  container: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  stack: {
    opacity: 0.9,
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    borderRadius: "6px",
    border: "solid 1px #EFF0EF",
    py: 4
  },
  audioIcon: {
    fontSize: 48
  },
  text: {
    mt: 1
  }
} as const;

type InsertScribeEmptyPanelProps = {
  isGettingStartedOn: boolean;
  isAudiologyMode: boolean;
  /** Unknown until the list's first read settles, so the panel never flashes a wrong prompt. */
  hasRecordings: boolean | undefined;
};

/** The right panel before a recording is picked. */
export default function InsertScribeEmptyPanel({
  isGettingStartedOn,
  isAudiologyMode,
  hasRecordings
}: InsertScribeEmptyPanelProps) {
  return (
    <Box sx={STYLES.container}>
      <Stack sx={STYLES.stack}>
        <AudioFileIcon sx={STYLES.audioIcon} />
        {!isGettingStartedOn ? (
          <Typography variant="body3" sx={STYLES.text}>
            {isAudiologyMode
              ? AUDIOLOGY_SELECT_PROMPT
              : "Please, select a Medical Scribe Record"}
          </Typography>
        ) : (
          hasRecordings !== undefined && (
            <Typography
              variant="body3"
              sx={STYLES.text}
              data-testid="insert-scribe-panel-prompt"
            >
              {getEmptyPanelPrompt({ hasRecordings, isAudiologyMode })}
            </Typography>
          )
        )}
      </Stack>
    </Box>
  );
}
